import React from 'react';
import css from '@src/js/Style';
import PropTypes from 'prop-types';
import View from '../Designer/View';
import Button from '../Designer/Button';
import Text from '../Designer/Text';
import AdaptiveTrait from '../../AdaptiveTrait';

export default class OfferCard extends React.Component {

    static get propTypes() {

        return {
            badge: PropTypes.any,
            title: PropTypes.string,
            mainImageLink: PropTypes.string,
            logoImageLink: PropTypes.string,
            mainImageAlt: PropTypes.string,
            logoImageAlt: PropTypes.string,
            promoText: PropTypes.string,
            buttonText: PropTypes.any,
            buttonLink: PropTypes.any,
            buttonSubText: PropTypes.any,
            hasBorder: PropTypes.bool,
        };
    }

    render() {

        const classes = ['flex flex-wrap mobile:w-full desktop:size-x-330 gap justify-center bg-white shadow-lg rounded-md p-6 overflow-x-clip'];
        if (this.props.hasBorder)
            classes.push('border border-warning');

        return (
            <View className={ classes.join(' ') }>

                {/* main image */}
                <View className='relative w-full flex justify-center'>
                    <img
                        className={ css('rounded-md w-80 desktop:w-full desktop:max-w-none') }
                        alt={ this.props.mainImageAlt }
                        src={ this.props.mainImageLink } />
                    { this.renderBadge() }
                </View>

                {/* logo image */}
                { this.renderLogoImage() }

                {/* title */}
                <Text className='text-medium text-center w-full'>{ this.props.title }</Text>

                {/* promo text */}
                { this.renderPromoText() }

                {/* button */}
                <Button
                    className={ 'button-primary-outline w-full mt-4' }
                    onClick={ () => this.onButtonClick() }
                    children={ this.props.buttonText } />

                {/* sub button text */}
                { this.renderButtonSubText() }

            </View>
        );
    }

    renderBadge() {

        if (!this.props.badge)
            return null;

        const classes = ['badge-warning badge-sm rounded-full transform translate-x-4 -translate-y-1/2'];
        if (AdaptiveTrait.isMobile())
            classes.push('icon-star aspect-square flex-center');

        const text = !AdaptiveTrait.isMobile()
            ? this.props.badge
            : '';

        return (
            <View className='absolute right-0 top-0 flex justify-end text-medium text-small'>
                <Text className={ classes.join(' ') }>
                    { text }
                </Text>
            </View>
        );
    }

    renderLogoImage() {

        if (!this.props.logoImageLink)
            return null;

        return (
            <img
                className={ css('size-x-120') }
                alt={ this.props.logoImageAlt }
                src={ this.props.logoImageLink } />
        );
    }

    renderPromoText() {

        if (!this.props.promoText)
            return null;

        return (
            <Text className='text-primary text-medium text-small w-full text-center' unsafe={ true }>
                { this.props.promoText }
            </Text>
        );
    }

    renderButtonSubText() {

        if (!this.props.buttonSubText)
            return null;

        return <Text className='text-muted text-small w-full text-center'>{ this.props.buttonSubText }</Text>;
    }

    onButtonClick() {

        window.open(this.props.buttonLink, '_blank');
    }

}